export default "__VITE_ASSET__88e6185b__"